import { useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

import { ROUTES, getPathName } from '@openclassrooms/routing';
import { getActiveLocale } from '@openclassrooms/translations';

import withStyles from '@mui/styles/withStyles';
import Box from '@classify/react-core-components/Box';
import { useTheme } from '@classify/react-core-components/styles';

import Logo, { LOGO_VARIANTS } from '../Logo';

const styles = ({ breakpoints, spacing }) => ({
  root: {
    marginRight: spacing(2),
  },
  link: {
    display: 'inline-block',
  },
  svg: {
    position: 'relative',
    top: 2,
    width: 40,
    [breakpoints.up('md')]: {
      width: 143,
    },
    [breakpoints.up('lg')]: {
      width: 208,
    },
  },
  auth: {
    display: 'flex',
    alignItems: 'center',
    height: 56,
    marginRight: spacing(0),
    [breakpoints.up('md')]: {
      height: 63,
    },
    '& svg': {
      width: 164,
      [breakpoints.up('sm')]: {
        width: 214,
      },
    },
  },
});

const MainHeaderLogo = ({
  classes = {},
  isAuth = false,
  isLegacy = false,
  onClick = () => {},
  ...otherProps
}) => {
  const theme = useTheme();
  const shouldUseSmallLogo = useMediaQuery(theme.breakpoints.down('md'));

  const authClassName = isAuth ? classes.auth : '';

  const linkProps = {
    className: classes.link,
  };
  let LinkComponent;

  if (isLegacy || document.location.pathname.startsWith('/us/')) {
    LinkComponent = 'a';
    linkProps.href = `/${getActiveLocale()}/`;
  } else {
    LinkComponent = Link;
    linkProps.to = getPathName(ROUTES.HOMEPAGE.INDEX, {}, false);
  }

  return (
    <Box
      id="mainHeaderLogo"
      className={`${classes.root} oc-mainHeaderLogo ${authClassName}`}
      {...otherProps}
    >
      <LinkComponent data-event="Button|Clicked|header-logo" onClick={onClick} {...linkProps}>
        <Logo
          className={classes.svg}
          variant={
            shouldUseSmallLogo && !isAuth ? LOGO_VARIANTS.COMPACT_BACKGROUND : LOGO_VARIANTS.NORMAL
          }
        />
      </LinkComponent>
    </Box>
  );
};

export default withStyles(styles)(MainHeaderLogo);
